import { RPM_PATIENT_STATUS } from "../constants";

export const welcomeMessageFieldsEnum = {
  welcomeMessageText: {
    fieldId: 'welcomeMessageText',
    required: message => { return message.set },
    readOnly: (_, stage) => { return stage !== RPM_PATIENT_STATUS.activated && stage !== RPM_PATIENT_STATUS.enrolled },
  },
  welcomeMessageDate: {
    fieldId: 'welcomeMessageDate',
    required: message => { return message.set && !message.send_on_enrollment_activation },
    readOnly: (_, stage) => { return stage !== RPM_PATIENT_STATUS.activated && stage !== RPM_PATIENT_STATUS.enrolled },
  },
  send_on_enrollment_activation: {
    fieldId: 'send_on_enrollment_activation',
    required: () => { return false },
    readOnly: (_, stage) => { return stage !== RPM_PATIENT_STATUS.activated && stage !== RPM_PATIENT_STATUS.enrolled },
  },
  send_on_first_event: {
    fieldId: 'send_on_first_event',
    required: () => { return false },
    readOnly: (_, stage) => { return stage !== RPM_PATIENT_STATUS.activated && stage !== RPM_PATIENT_STATUS.enrolled },
  },
};

export const initializeWelcomeMessage = (message, defaultWelcomeMessage, scheduledWelcomeMessage) => {
  if (scheduledWelcomeMessage?.message) {
    return {
      ...message,
      ...scheduledWelcomeMessage,
      set: true,
      text: scheduledWelcomeMessage.message,
    };
  }

  return {
    ...message,
    text: defaultWelcomeMessage,
  };
};

export const welcomeMessageToDTO = (message, patient, kitId) => {
  return {
    user_id: patient.id,
    kit_id: kitId,
    message: message.text,
    schedule_at: message.send_on_enrollment_activation ? undefined : message.dateTime?.format(),
    send_on_enrollment_activation: message.send_on_enrollment_activation,
    send_on_first_event: message.send_on_first_event,
  };
};
